import { useCallback } from 'react';

import { MeResponseSchema } from '../../../api';
import { useApiClient } from '../../../lib/api/api-context';
import { useApiQuery } from '../../../lib/api/use-api-query';

/**
 * Whether Home says identification was lost (S4 R18, Proposal P2, Q-new-7): one `GET /me` when E2
 * opens, own hook because the Home feature does not export `useMe` and features may not import each
 * other's internals. A failed read is `false`: the banner is a courtesy and must never block E2.
 */
export function useSessionLost(): boolean {
  const api = useApiClient();
  const load = useCallback(
    (signal: AbortSignal) => api.get('/me', MeResponseSchema, signal),
    [api],
  );
  const result = useApiQuery(load);
  return (
    result.status === 'success' &&
    result.data.status.status === 'blocked' &&
    result.data.status.causes.some((cause) => cause.reasonCode === 'TELEGRAM_SESSION_LOST')
  );
}
